// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","body":"TwilioStartHelper_body__Ne3TU","header":"TwilioStartHelper_header__t6fPt","svg":"TwilioStartHelper_svg__DV66K"};